<div class="main-menu">
  @if (!isMobile()) {
    <div class="menu-header" [class.menu-header--expanded]="!collapsed()">
      <button
        mat-icon-button
        (click)="toggleCollapsed()"
        [matTooltip]="collapsed() ? 'Expand menu' : 'Collapse menu'"
        [attr.aria-label]="collapsed() ? 'Expand menu' : 'Collapse menu'"
        [attr.aria-expanded]="!collapsed()">
        <mat-icon class="material-symbols-outlined">
          {{ collapsed() ? 'menu' : 'menu_open' }}
        </mat-icon>
      </button>
    </div>
  }

  @if (showRail()) {
    <div class="menu-rail">
      @for (item of mainMenuList; track item.name) {
        <div
          class="menu-rail-item"
          [class.active]="isGroupActive(item)"
          cdkOverlayOrigin
          #origin="cdkOverlayOrigin"
          (mouseenter)="openGroup(item.iconName)"
          (mouseleave)="scheduleClose()">
          <button mat-icon-button>
            <mat-icon class="material-symbols-outlined">{{
              item.iconName
            }}</mat-icon>
          </button>
        </div>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="origin"
          [cdkConnectedOverlayOpen]="hoveredGroup() === item.iconName"
          [cdkConnectedOverlayPositions]="flyoutPositions"
          [cdkConnectedOverlayPanelClass]="['main-menu-flyout-panel', 'dark']">
          <div
            class="menu-flyout"
            (mouseenter)="openGroup(item.iconName)"
            (mouseleave)="scheduleClose()">
            <div class="menu-flyout-header">{{ item.name | titlecase }}</div>
            <mat-nav-list>
              <ng-container
                *ngTemplateOutlet="childrenList; context: { $implicit: item }">
              </ng-container>
            </mat-nav-list>
          </div>
        </ng-template>
      }
    </div>
  } @else {
    <mat-nav-list class="menu-list">
      <mat-accordion multi="true">
        @for (item of mainMenuList; track item.name) {
          <mat-expansion-panel
            class="menu-group-panel"
            [expanded]="step() === item.iconName"
            (opened)="setStep(item.iconName)">
            <mat-expansion-panel-header class="menu-group-header">
              <mat-panel-title class="menu-group-title">
                <mat-icon class="material-symbols-outlined">{{
                  item.iconName
                }}</mat-icon>
                {{ item.name | titlecase }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-container
              *ngTemplateOutlet="childrenList; context: { $implicit: item }">
            </ng-container>
          </mat-expansion-panel>
        }
      </mat-accordion>
    </mat-nav-list>
  }
</div>

<ng-template #childrenList let-item>
  @for (
    child of item.children;
    track child.route;
    let idx = $index, last = $last
  ) {
    @if (child.route !== '/rights-map' || showAllRoutes()) {
      @if (child.name === 'Series') {
        <mat-divider class="menu-divider"></mat-divider>
        <div class="menu-subheader">Collections</div>
      }
      @if (child.name === 'Instant Games') {
        <mat-divider class="menu-divider"></mat-divider>
        <div class="menu-subheader">Gamification</div>
      }
      @if (child.name === 'Import Music') {
        <div class="menu-subheader">Music</div>
      }
      @if (child.name === 'Media Explorer') {
        <div class="menu-subheader">Videos</div>
      }
      <a
        mat-list-item
        [routerLink]="child.route || '/'"
        [routerLinkActive]="['active']"
        (click)="hoveredGroup.set(null)">
        <mat-icon matListItemIcon class="material-symbols-outlined">{{
          child.iconName
        }}</mat-icon>
        {{ child.name === 'Live TV' ? 'Live TV' : (child.name | titlecase) }}
      </a>
      @if (
        child.name === 'Subtitle validation' ||
        child.name === 'Extract audio' ||
        child.name === 'Restoration'
      ) {
        <mat-divider class="menu-divider"></mat-divider>
      }
    }
  }
</ng-template>
